// =========================================================================
// This function is for getting the discount type ( % | number)

import { RateAmountType } from '@api/index';

// =========================================================================
export const getDiscountType = (type?: RateAmountType) => {
  return type === RateAmountType.PERCENTAGE
    ? 'percent'
    : type === RateAmountType.VALUE
    ? 'value'
    : 'percent';
};
